import { TranslationKey } from './../../../../../types/translation/TranslationKey';

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { t } from '../../../../../types/translation/Translator';
import { Button } from '../../../../components/Button';
import { ButtonVariant } from '../../../../components/Button/Button';
import Icon, { IconType } from '../../../../icons/Icon';
import { OnboardingStep, OnboardingTitle } from '../../components';
import OnboardingPaneHeader from '../../components/OnboardingPaneHeader';
import { OnboardingData, OnboardingRoutes } from '../..';
import OnboardingReferenceDataItem from './components/OnboardingReferenceDataItem';

interface OnboardingReferenceDataOverviewPaneProps {
  data: OnboardingData;
}

export default function OnboardingReferenceDataOverviewPane({ data }: OnboardingReferenceDataOverviewPaneProps) {
  const navigate = useNavigate();

  return (
    <div className='grid gap-4 overflow-auto'>
      <OnboardingPaneHeader back={() => navigate(OnboardingRoutes.referenceDataImport)} />

      <div className='grid gap-1'>
        <OnboardingStep />
        <OnboardingTitle text={'Overview of your reference data'} />
      </div>

      <div className='flex items-center gap-2'>
        <Icon type={IconType.checkCircle} size={'h-4 w-4'} stroke={'stroke-success-500'} />
        <p className='text-sm text-gray-600'>
          {data.summary.productMasterData.size} Reference Data added to your company
        </p>
      </div>

      <div className='grid gap-2 overflow-auto'>
        <p className='text-sm font-medium text-black'>Reference Data added</p>
        <div className='grid gap-2 overflow-auto'>
          {[...data.summary.productMasterData.entries()]
            .sort((a, b) => (a[1].productName > b[1].productName ? 1 : -1))
            .map(([number, pmd]) => (
              <OnboardingReferenceDataItem productMasterData={pmd} key={number} />
            ))}
        </div>
        <Button
          text={'Add new reference data'}
          variant={ButtonVariant.linkPrimary}
          leading={<Icon type={IconType.plusCircle} size={'h-4 w-4'} />}
          onClick={() => navigate(OnboardingRoutes.referenceDataAdd)}
        />
      </div>

      <div className='flex gap-2'>
        <Button text={t(TranslationKey.next).singular.label} onClick={() => navigate(OnboardingRoutes.stockImport)} />
      </div>
    </div>
  );
}
